<template>
  <ul :class="rootClassName">
    <slot />
  </ul>
</template>

<script>

export default {
  name: 'Tabs',

  props: {
    value: {
      type: [ Number, String ]
    },

    variant: {
      type: String,
      default: 'underlined',
      validator: v => [
        'underlined',
        'divided',
        'dividing'
      ].includes(v)
    },

    size: {
      type: String,
      default: 'medium',
      validator: v => [
        'small',
        'medium'
      ].includes(v)
    }
  },


  reactiveProvide: {
    name: 'Tabs',
    include: [
      'value',
      'variant',
      'size',
      'handleChange'
    ]
  },

  methods: {
    handleChange (value) {
      this.$emit('input', value)
    }
  },

  computed: {
    rootClassName () {
      return [
        this.$style.root,
        this.$style[this.variant]
      ]
    }
  }
}

</script>

<style module>

.root {
  @apply
    flex
    items-start
    w-full
    m-0
    p-0
    list-none;
}

.dividing:before {
  content: "";
  width: 48px;
  margin-right: -1px;
	align-self: flex-end;
	@apply 
		border-b
		border-solid
		border-dull;
}

.dividing:after {
  content: "";
  width: 48px;
  margin-left: -1px;
	align-self: flex-end;
	@apply 
		border-b
		border-solid
		border-dull;
}

</style>
